import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Redux/Store/index";
import { NotificationContainer } from "react-notifications";
import { LoadingAlert } from "./Common";
import "react-notifications/lib/notifications.css";
import { Routers } from "./Router/Routers";
import "./index.css";

// ✅ SETUP GLOBAL ERROR HANDLER - Catch tất cả unhandled promise rejection
import { setupGlobalErrorHandler } from "./Redux/Actions/GlobalSafeWrapper";
import {
  startVersionCheck,
  checkVersionNow,
  resetVersion,
  getVersionInfo,
} from "./Utils";
import { ConfigProvider } from "antd";
setupGlobalErrorHandler();

// ✅ START VERSION CHECK - Tự động kiểm tra version mới và reload
startVersionCheck();

// ✅ EXPOSE FUNCTIONS TO CONSOLE FOR TESTING
if (process.env.NODE_ENV !== "production") {
  window.checkVersionNow = checkVersionNow;
  window.resetVersion = resetVersion;
  window.getVersionInfo = getVersionInfo;
  console.log("🔧 Version check functions available in console:");
  console.log("  - window.checkVersionNow() : Force check version");
  console.log("  - window.resetVersion()    : Reset version for testing");
  console.log("  - window.getVersionInfo()  : Get current version info");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: { colorPrimary: "#00884e" },
          components: {
            Splitter: {
              splitTriggerSize: 10,
              splitBarSize: 4,
              resizeSpinnerSize: 40,
            },
            Segmented: {
              itemSelectedBg: "#00884e",
              itemSelectedColor: "#fff",
            },
            Table: {
              headerBg: "#fff7ed",
            },
            Drawer: {
              mask: false,
            },
          },
        }}
      >
        <Routers />
        <NotificationContainer />
        <LoadingAlert />
      </ConfigProvider>
    </Provider>
  </BrowserRouter>
);
